var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("门诊预约问诊管理")]),
            _c("el-breadcrumb-item", [_vm._v("专家标签管理")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-form",
          {
            ref: "listForm",
            attrs: {
              model: _vm.listParams,
              "label-width": "120px",
              inline: "",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "标签搜索：", prop: "label" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入标签关键字" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchTree.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.listParams.label,
                    callback: function ($$v) {
                      _vm.$set(_vm.listParams, "label", $$v)
                    },
                    expression: "listParams.label",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "", prop: "" } },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.searchTree } },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-popover",
          {
            attrs: { placement: "top" },
            model: {
              value: _vm.visible,
              callback: function ($$v) {
                _vm.visible = $$v
              },
              expression: "visible",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("el-input", {
                  attrs: { size: "small" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.addRootNode.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.label,
                    callback: function ($$v) {
                      _vm.label = $$v
                    },
                    expression: "label",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.addRootNode },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { slot: "reference", type: "primary" },
                slot: "reference",
              },
              [_vm._v("添加一级节点")]
            ),
          ],
          1
        ),
        _c("el-tree", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "tree",
          staticStyle: { "margin-top": "20px" },
          attrs: {
            data: _vm.treeList,
            props: _vm.defaultProps,
            "node-key": "id",
            "expand-on-click-node": false,
            "filter-node-method": _vm.filterNode,
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ node, data }) {
                return _c("span", { staticClass: "custom-tree-node" }, [
                  _c("span", [_vm._v(_vm._s(node.label))]),
                  _c(
                    "span",
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: { placement: "top", width: "160" },
                          model: {
                            value: data.addVisible,
                            callback: function ($$v) {
                              _vm.$set(data, "addVisible", $$v)
                            },
                            expression: "data.addVisible",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: { size: "small" },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.addLabel(data)
                                  },
                                },
                                model: {
                                  value: _vm.label,
                                  callback: function ($$v) {
                                    _vm.label = $$v
                                  },
                                  expression: "label",
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addLabel(data)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                          _c("i", {
                            staticClass: "el-icon-circle-plus mgl10",
                            attrs: { slot: "reference" },
                            on: {
                              click: function ($event) {
                                return _vm.addShow(data)
                              },
                            },
                            slot: "reference",
                          }),
                        ]
                      ),
                      _c(
                        "el-popover",
                        {
                          attrs: { placement: "top", width: "160" },
                          model: {
                            value: data.editVisible,
                            callback: function ($$v) {
                              _vm.$set(data, "editVisible", $$v)
                            },
                            expression: "data.editVisible",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: { size: "small" },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.editLabel(data)
                                  },
                                },
                                model: {
                                  value: _vm.label,
                                  callback: function ($$v) {
                                    _vm.label = $$v
                                  },
                                  expression: "label",
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editLabel(data)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                          _c("i", {
                            staticClass: "el-icon-edit-outline mgl5",
                            attrs: { slot: "reference" },
                            on: {
                              click: function ($event) {
                                return _vm.editShow(data)
                              },
                            },
                            slot: "reference",
                          }),
                        ]
                      ),
                      data.subDepartments.length === 0
                        ? _c(
                            "confirm-button",
                            {
                              attrs: {
                                type: "text",
                                title: `确认要删除"${data.name}"吗？`,
                              },
                              on: {
                                confirmed: function ($event) {
                                  return _vm.deleteLabel(node, data)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-delete mgl5" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }